import React, { useEffect, useState } from 'react'
import Layout from '../component/Layout/Layout'
import { usePageAPI } from '../hooks/useAllCategoryData';
import parse from "html-react-parser";
import { useNavigate, useParams } from 'react-router-dom';

export default function Pages() {
    const { slug } = useParams();
    const navigate = useNavigate();
    const { isLoading, error, data, failureCount } = usePageAPI(slug);
    const [countryCode, setCountryCode] = useState("");
    useEffect(() => {
        const countryData = JSON.parse(sessionStorage.getItem("country_data"));
        if (countryData?.code) {
            setCountryCode(countryData.code); // Ensure state updates
        }
    }, []);

    if (error) return <div>{error.message}</div>;
    console.log(countryCode);
    if (failureCount > 0) {
        navigate("/notfound", { replace: true });
    }
    const rawDescription = (countryCode === "AED" && data?.page?.description_dubai)
        ? data.page.description_dubai
        : data?.page?.description;

    const safeDescription = typeof rawDescription === "string" ? parse(rawDescription) : null;
    return (
        <Layout title={`${data?.page.meta_title ? data.page.meta_title : data?.page.title} | Chaashni Couture`} description={data?.page.meta_description} keywords={data?.page.meta_keyword} >
            <div className="site-content-wrap static-page">
                <div className="container">
                    <div className="row">
                        {isLoading && (
                            <div className='loading-div'><span>Loading...</span></div>
                        )}
                        <div className="col-md-12">
                            <h1 className="sustom-heading-h1">{data?.page.title} </h1>
                            <div className="content-box">
                                {safeDescription}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}